<template>
  <a
    v-if="url"
    class="button-primary"
    :style="style"
    :href="url"
    target="_blank"
    @click="pushEvent"
  >
    {{ label }}
  </a>

  <router-link
    v-else-if="internalUrlParam"
    class="button-primary"
    :style="style"
    :to="{ name: 'page', params: { page: internalUrlParam || 'home' } }"
  >
    {{ label }}
  </router-link>

  <button
    v-else
    class="button-primary"
    :style="style"
    @click="$emit('onClick')"
  >
    {{ label }}
  </button>
</template>

<script setup>
import { computed } from "vue";
import { pushData } from "@/utilities/analytics-functions.js";

const props = defineProps({
  label: String,
  black: Boolean,
  white: Boolean,
  url: String,
  internalUrlParam: String,
});

const style = computed(() => ({
  "--bg-color": bgColor.value,
  "--hover-color": hoverColor.value,
  "--text-color": textColor.value,
}));

const bgColor = computed(() => {
  return props.white
    ? `var(--white-10)`
    : props.black
    ? `var(--black-10)`
    : `var(--primary-yellow)`;
});

const hoverColor = computed(() => {
  return props.white
    ? `var(--white-25)`
    : props.black
    ? `var(--black-25)`
    : `var(--primary-yellow-light)`;
});

const textColor = computed(() => {
  return props.white ? `var(--white-100)` : `var(--black-100)`;
});

function pushEvent() {
  if (props.url && props.url.includes(".pdf")) {
    pushData("pdf", props.url, "", props.label);
  }
}
</script>

<style lang="scss" scoped>
.button-primary {
  @include link-l;

  border-radius: 6px;
  padding: 1rem toRem(36);
  background-color: var(--bg-color);
  color: var(--text-color);
  width: fit-content;
  transition: background-color 0.3s;

  &:hover:not(:disabled) {
    background-color: var(--hover-color);
  }

  .mobile & {
    padding: 1rem 1.5rem;
  }
}
</style>
